import type { paths } from "@/api-schema";
import { useJobFunctionByUuidQuery } from "@/common/api/job-function/use-job-function-by-uuid.query";
import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { UuidExistenceWrapper } from "@/components/uuid-existence-wrapper/uuid-existence-wrapper";
import { useTranslation } from "react-i18next";
import { useParams } from "wouter";
import { JobFunctionFormFields } from "../_components/job-function-form-fields";

interface UpdateViewParams {
  uuid: string;
}

export function UpdateView() {
  const { t } = useTranslation(["masterdata", "common"]);
  const params = useParams<UpdateViewParams>();
  const uuid = params.uuid;

  return (
    <UuidExistenceWrapper<
      paths["/v1/job-function/{uuid}"]["get"]["parameters"]["query"],
      paths["/v1/job-function/{uuid}"]["get"]["responses"][200]["content"]["application/json"]
    >
      uuid={uuid}
      query={useJobFunctionByUuidQuery}
      notFoundProps={{
        title: t("masterdata:JobFunctionNotFound"),
        message: t("masterdata:JobFunctionDoesNotExist"),
        description: t("masterdata:PleaseCheckJobFunctionIdOrContactSupport"),
        backTo: "~/masterdata/job-function",
        backToLabel: t("masterdata:BackToJobFunctionOverview"),
      }}
    >
      <UpdateViewContent uuid={uuid} />
    </UuidExistenceWrapper>
  );
}

function UpdateViewContent({ uuid }: { uuid: string }) {
  const { t } = useTranslation(["masterdata", "common"]);
  const pageTitle = t("masterdata:EditJobFunction");
  const pageSubtitle = t("common:ReviewAndSaveChangesDescription");

  return (
    <CenteredLayout variant={CenteredLayoutVariant.Form} title={pageTitle} subTitle={pageSubtitle}>
      <JobFunctionFormFields uuid={uuid} />
    </CenteredLayout>
  );
}
